import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routerActions } from "connected-react-router";

import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import classNames from "classnames";
import { actions as accountsActions } from "reducers/accounts";
import CustomData from "pages/_components/CustomData/CustomData";
import { Link, useParams } from "react-router-dom";
import { useGetAccount } from "hooks/useAccounts";
import { Col, Row } from "react-bootstrap";
import Credential from "pages/_components/fields/credentials/Credential";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "pages/_components/Button";
import { actions as debinActions } from "reducers/debin";
import Check from "pages/_components/fields/Checkbox";
import gaEventTracker, { events } from "util/gaEventTracker";

const AddAccountConfirmation = () => {
    const { id } = useParams();
    const [isValidating, setIsValidating] = useState(false);
    const dispatch = useDispatch();
    const account = useGetAccount(id);
    const { status } = useSelector((state) => state.debin.addVendorAccount);
    const [formRef, setFormRef] = useState();
    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);
    useEffect(() => {
        if (status === "INVALID_CREDENTIAL") {
            setIsValidating(false);
            formRef.setErrors({
                credential: i18n.get("preferences.password.password.incorrect"),
            });
            dispatch(debinActions.cleanDebinStatus());
        } else if (status === "FAILURE") {
            dispatch(debinActions.cleanDebinStatus());
            dispatch(routerActions.goBack());
        } else if (status === "SUCCESS") {
            dispatch(debinActions.cleanDebinStatus());
            dispatch(routerActions.goBack());
        }
    }, [status]);

    const handleSubmit = ({ credential }) => {
        setIsValidating(true);
        gaEventTracker.triggerEvent(events.debin_adherir_cuentas_enviar());
        dispatch(
            debinActions.addNewVendorAccount({
                _password: credential,
                idAccount: id,
            }),
        );
    };

    const accountName = () => {
        let name;
        if (account?.label === "alias not set") {
            name = i18n.get("accounts.accountLabel.alias");
        } else {
            name = account?.label;
        }
        return name;
    };
    const maskAccountNumber = (accountNumber) => {
        const mask = "****";
        if (accountNumber) {
            return mask + accountNumber.slice(-4);
        }
        return mask;
    };

    return (
        <>
            <ResponsiveHeader id="debin.addAccount.title" backLinkTo="/debinPayments/addAccount" />
            <MainContainer>
                <h3>
                    <CustomText text="Confirmá adhesión" textType="TEXT" className="custom-text custom-data-title" />
                </h3>
                <GridTable className={classNames("details debin-credin-list")}>
                    <GridTable.Container rowId="informationTableRow" columns={3} rows={2} key="informationTable">
                        <GridTable.Data key={1} columnStart={1} rowStart={1} alignX="flex-start" alignY="flex-start">
                            <CustomData
                                titleText="debin.addAccount.name"
                                titleTextType="I18N"
                                valueText={accountName()}
                            />
                        </GridTable.Data>
                        <GridTable.Data key={2} columnStart={2} rowStart={1} alignX="flex-start" alignY="flex-start">
                            <CustomData
                                titleText="accounts.create.accountType"
                                titleTextType="I18N"
                                valueText={`${i18n.get(`accounts.accountType.${account?.accountType}`)} en ${
                                    account?.currency
                                }`}
                            />
                        </GridTable.Data>
                        <GridTable.Data key={3} columnStart={3} rowStart={1} alignX="flex-start" alignY="flex-start">
                            <CustomData
                                titleText="debin.n.cuenta"
                                titleTextType="I18N"
                                valueText={maskAccountNumber(account?.accountNumber)}
                            />
                        </GridTable.Data>
                        <GridTable.Data key={4} columnStart={1} rowStart={2} alignX="flex-start" alignY="flex-start">
                            <CustomData
                                titleText="debin.cbu"
                                titleTextType="I18N"
                                valueText={account?.cbu?.substring(9)}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                <Formik
                    ref={(el) => setFormRef(el)}
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                    }}
                    validationSchema={Yup.object().shape({
                        credential: Yup.string().required(i18n.get("deposits.request.required")),
                    })}
                    onSubmit={handleSubmit}>
                    {({ isSubmitting, values }) => (
                        <Form>
                           
                            <Row className="form-actions">
                                <Col xs={12} md={4} mdOffset={2} lg={3} lgOffset={3}>
                                    {" "}
                                    <Field
                                        idForm="form.credential"
                                        name="credential"
                                        labelText="form.credential.password.label"
                                        placeholderText="Ej: 120573"
                                        component={Credential}
                                        type="password"
                                    />
                                </Col>
                                <Col xs={12} md={4} mdOffset={6} lg={3} lgOffset={6} className="align-items-end">
                                    <div className="form-group">
                                        <div className="form-group">
                                            <span className="data-label">
                                                <span> &nbsp;</span>
                                            </span>
                                            <div className="button-group">
                                                <Button
                                                    block
                                                    type="submit"
                                                    label="global.send"
                                                    bsStyle="primary"
                                                    loading={isSubmitting && isValidating}
                                                    disabled={!values.credential.length > 0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

export default AddAccountConfirmation;
